import { defineComponent as _defineComponent } from 'vue';
import getCurrentHost from '~/utils/getCurrentHost';
export default /*#__PURE__*/_defineComponent({
  __name: 'default',
  setup: function setup(__props) {
    var host = getCurrentHost();
    useTimeTracking();
    return {
      __sfc: true,
      host: host
    };
  }
});